// ======================================================================
// File Name       : UserHistoryCourseTopContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, Button } from 'react-bootstrap';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import * as CourseHistoryActions from '../../../actions/UserHistoryCourseAction';
import * as Path from '../../../constants/PathConstants';
import CourseListSearchInput from '../../../components/userHistory/course/CourseHistorySearchInput';
import CourseListSearchResult from '../../../components/userHistory/course/CourseHistorySearchResult';
import RenderField from '../../../utils/ReduxFormUtils';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../../../constants/index';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';
import * as actionType from '../../../constants/actionTypes/page';

class CourseHistoryListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startPosition: 0,
      courseStatusSortType: null,
      ascendingDescendingSort: 0,
      returnMaxNum: RETURN_MAX_NUM,
      isAllowShowSearchMessage: false,
    };
    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: Path.USER_HISTORY_COURSE_LIST,
        searchCondition: formValues,
      });
    }
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.courseStatusSortType) {
        column = initialValues.courseStatusSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(false, initialValues, column, startPosition);
    const data = {
      courseName: initialValues.courseName,
    };
    this.props.dispatch(CourseHistoryActions.initSearchInput(data));
    this.props.dispatch(CourseHistoryActions.searchUserHistoryCourse(param));
  }

  createParams(isCSV, data, column, startPosition) {
    const filterData = { ...data };
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.courseStatusSortType = column.sortBy;
    }

    if (!column) {
      filterData.ascendingDescendingSort = 0;
      filterData.courseStatusSortType = null;
    }

    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;

    const param = {
      selectTargetData,
      searchInfo: filterData,
    };
    return param;
  }

  goToDetail(courseSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: Path.USER_HISTORY_COURSE_LIST,
        searchCondition: formValues,
      });
    }
    const path = Path.USER_HISTORY_COURSE_DETAIL.replace(':id', courseSecernId);
    this.props.history.push(path);
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      startPosition: formValues.startPosition,
      courseStatusSortType: formValues.courseStatusSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      courseName: formValues.courseName,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('courseStatusSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(CourseHistoryActions.initSearchInput(paramSearch.courseName));
      this.props.dispatch(CourseHistoryActions.searchUserHistoryCourse(paramSearch))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  searchData(startPosition, column) {
    const { filterData } = this.state;
    const { invalid, dispatch, formValues } = this.props;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(false, filterData, column, startPosition);
    this.props.dispatch(CourseHistoryActions.initSearchInput(paramSearch.courseName));
    this.props.dispatch(CourseHistoryActions.searchUserHistoryCourse(paramSearch))
    .then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.courseStatusSortType) {
      column = formValues.courseStatusSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }


  render() {
    const { userHistoryCourseList, courseList, courseStatus, recordNum } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={courseList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <CourseListSearchInput
          searchInfo={userHistoryCourseList}
          onSearchCourse={this.clickSearchButton}
        />
        <CourseListSearchResult
          courseHistoryList={courseList}
          handleSortState={this.handleSortState}
          courseHistoryStatus={courseStatus}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={this.state.startPosition}
          goToDetail={this.goToDetail}
          dataSort={this.state}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userHistoryCourseList } = state.form;
  const { courseList } = state.userHistoryCourse;
  const { courseStatus } = state.userHistoryCourse;
  const { courseListSearchInit } = state.userHistoryCourse;
  const { recordNum } = state.userHistoryCourse;
  const { parentPath, searchCondition } = state.page;
  let initial = {};
  if (parentPath === Path.USER_HISTORY_COURSE_LIST) {
    if (searchCondition) {
      const paramSearch = {};
      paramSearch.courseName = searchCondition.courseName;
      paramSearch.courseStatusSortType = searchCondition.courseStatusSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      initial = paramSearch;
    }
  }
  return {
    ...{ userHistoryCourseList },
    ...{ courseList },
    ...{ courseStatus },
    ...{ recordNum },
    initialValues: initial,
    searchCondition,
    parentPath,
    formValues: getFormValues('userHistoryCourseList')(state),
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'userHistoryCourseList',
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  touchOnChange: true,
})(CourseHistoryListContainer));
